/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Linear_Kb5Inputs */

const en_mk_cmp_linear_kb5 = /** @type {(inputs: Mk_Cmp_Linear_Kb5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent work quota is included in the seat price.`)
};

const id_mk_cmp_linear_kb5 = /** @type {(inputs: Mk_Cmp_Linear_Kb5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuota kerja agen sudah termasuk di harga kursi.`)
};

/**
* | output |
* | --- |
* | "Agent work quota is included in the seat price." |
*
* @param {Mk_Cmp_Linear_Kb5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_linear_kb5 = /** @type {((inputs?: Mk_Cmp_Linear_Kb5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Linear_Kb5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_linear_kb5(inputs)
	return en_mk_cmp_linear_kb5(inputs)
});